import React from 'react';
import { twMerge } from 'tailwind-merge';

export function TextArea(
  props: React.TextareaHTMLAttributes<HTMLTextAreaElement>,
) {
  const { className, ...rest } = props;

  return (
    <textarea
      {...rest}
      className={twMerge(
        'w-full rounded-lg border border-seeker-700 bg-transparent px-4 py-3.5 text-sm text-white outline-none transition-colors placeholder:text-seeker-400 hover:border-seeker-500 focus:border-white [&:user-invalid]:border-orange-400 [&:user-invalid]:focus:border-orange-400',
        className,
      )}
    />
  );
}
